import React, { useEffect, useState, useCallback } from "react";
import { useApi } from "../context/ApiContext";
import Button from "../components/ui/Button";
import "./CollectionSummary.css";

export default function CollectionsSummary({ refreshFlag, children }) {
    const { apiFetch } = useApi();
    const [cols, setCols] = useState([]);
    const [error, setError] = useState(null);
    const [toDelete, setToDelete] = useState(null);

    const refresh = useCallback(() => {
        apiFetch("/collections")
            .then(r => r.json())
            .then(j => j.success ? setCols(j.data) : setError(j.error || "Erreur"))
            .catch(e => setError(e.message));
    }, [apiFetch]);

    useEffect(() => {
        refresh();
    }, [refresh, refreshFlag]);

    const confirmDelete = async () => {
        if (!toDelete) return;

        const res = await apiFetch(`/collections/${encodeURIComponent(toDelete)}`, {
            method: "DELETE"
        }).then(r => r.json());

        if (res.success) {
            setToDelete(null);
            refresh();
        } else {
            setError(res.error || "Erreur API");
        }
    };

    return (
        <section className="card" id="collections-summary">
            <div className="card__head">
                <h2>Collections</h2>
                <p>Une collection = un client</p>
            </div>

            <div className="card__body">
                {error && <p className="notice notice--error">{error}</p>}

                {cols.length === 0
                    ? <p className="empty">Aucune collection.</p>
                    : (
                        <ul id="collections-list">
                            {cols.map(col => (
                                <li key={col} className="collection-item">
                                    <span>{col}</span>
                                    {/* La suppression détruit toute la mémoire du client :
                                        elle mérite un bouton explicite, pas un clic sur la puce. */}
                                    <button type="button" className="collection-item__del"
                                            aria-label={`Supprimer la collection ${col}`}
                                            onClick={() => setToDelete(col)}>×</button>
                                </li>
                            ))}
                        </ul>
                    )}

                {children}
            </div>

            {toDelete && (
                <div id="cs-modal-backdrop" onClick={() => setToDelete(null)}>
                    <div id="cs-modal" onClick={e => e.stopPropagation()}>
                        <p>Supprimer la collection <strong>{toDelete}</strong> ?<br />
                            Toutes les données associées seront perdues.</p>
                        <div className="cs-actions">
                            <Button variant="secondary" onClick={() => setToDelete(null)}>Annuler</Button>
                            <Button variant="danger" onClick={confirmDelete}>Supprimer</Button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
